export class ReportStartUpInstructionsModel {
enumReportCategoryID: string;
ReportID: string;
ShowViewer: boolean;
SavePDF: boolean;
Print: string;
}
